export enum NotificationActionTypes {
    GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT",
    SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT",
    NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED",
}

export interface IGetNotificationCount {
    readonly type: NotificationActionTypes.GET_NOTIFICATION_COUNT
}

export interface ISetNotificationCount {
    readonly type: NotificationActionTypes.SET_NOTIFICATION_COUNT
    readonly countNotifications: number
}

export interface INotificationReceived {
    readonly type: NotificationActionTypes.NOTIFICATION_RECEIVED
    readonly receivedAt: number
}

export const getNotificationCount = (): IGetNotificationCount => ({
    type: NotificationActionTypes.GET_NOTIFICATION_COUNT,
})

export const setNotificationCount = (countNotifications: number): ISetNotificationCount => ({
    type: NotificationActionTypes.SET_NOTIFICATION_COUNT,
    countNotifications,
})

export const notificationReceived = (): INotificationReceived => ({
    type: NotificationActionTypes.NOTIFICATION_RECEIVED,
    receivedAt: Date.now(),
})

export type NotificationAction =
    | IGetNotificationCount
    | ISetNotificationCount
    | INotificationReceived
